import { render } from "./ContactCheckout.vue?vue&type=template&id=ba2cef9a"
import script from "./ContactCheckout.vue?vue&type=script&lang=ts"
export * from "./ContactCheckout.vue?vue&type=script&lang=ts"
script.render = render

export default script